import React from 'react';

/**
 * Marks a subtree as a read-only content preview (e.g. the hover preview in the
 * content list). Used to suppress side-effects that would otherwise fire from
 * mounting real content views — analytics events and view/usage tracking.
 */
const ContentPreviewContext = React.createContext<{
  isContentPreview: boolean;
}>({ isContentPreview: false });

export default ContentPreviewContext;
